<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg-default">{{ $t('Научно-исследовательские работы') }}</h1>
    <div class="research-work">
      <v-treeview
        :items="catalogs"
        open-on-click
        transition
      >
        <template v-slot:prepend="{ item, open }">
          <template v-if="item.file">
            <v-icon>
              mdi-file-document-outline
            </v-icon>
            <a :href="backUrl + item.file" target="_blank">{{ item.label }}</a>
          </template>
          <template v-else>
            <v-icon>
              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
            </v-icon>
            {{ item.label }}
          </template>
        </template>
      </v-treeview>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import ooptResearch from '@/model/ooptResearch'

export default {
  data: () => ({
    breadcrumbs: [],
    catalogs: [],
    backUrl: process.env.VUE_APP_BACK_URL
  }),
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),

    fetchData () {
      this.setLoading(true)
      ooptResearch.allResearchWorks()
        .then((res) => {
          this.catalogs = res.data.catalogs

          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: '/'
            },
            {
              text: this.$i18n.t('Научно-исследовательские работы'),
              disabled: true
            }
          ]
          this.scrollToTop()
          this.setLoading(false)
        })
        .catch((err) => {
          this.setLoading(false)
          console.log(err)
        })
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}

</script>

<style scoped>

</style>
